/*! hash:236adc3a1b5ab40120ca, chunkhash:2af3d543eecd78d6ac8b, name:app, filebase:app.2af3d543e.js, query:, file:assets/js/app.2af3d543e.js */
webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 项目公共逻辑和方法
var app = {};
app.switchUA = function (page) {
  if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
    if (page == 'pc') {
      location.replace("/m/index.html");
    }
  } else {
    if (page == 'm') {
      location.replace("/pc/index.html");
    }
  }
};

exports.default = app;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]);


// WEBPACK FOOTER //
// assets/js/app.2af3d543e.js